import { deleteStoredCountries, getAcceptableCountries, hasStoredCountries } from "./Countries/localStorage";
import { deleteStoredFieldsOfEducation, getStoredFieldsOfEducation, hasStoredFieldsOfEducation } from "./FieldsOfEducation/localStorage";
import { deleteStoredIntakes, getStoredIntakes, hasStoredIntakes } from "./Intakes/localStorage";
import { deleteStoredProgramLevelFamilies, getStoredProgramLevelFamily, hasStoredProgramLevelFamilies } from "./ProgramLevelFamilies/localStorage";
export var StoredPreferences = {
  deleteAll: function deleteAll() {
    deleteStoredCountries();
    deleteStoredFieldsOfEducation();
    deleteStoredIntakes();
    deleteStoredProgramLevelFamilies();
  },
  getCountries: function getCountries() {
    return hasStoredCountries() ? getAcceptableCountries() : null;
  },
  getFieldsOfEducation: function getFieldsOfEducation() {
    return hasStoredFieldsOfEducation() ? getStoredFieldsOfEducation() : null;
  },
  getIntakes: function getIntakes() {
    return hasStoredIntakes() ? getStoredIntakes() : null;
  },
  getProgramLevelFamilies: function getProgramLevelFamilies() {
    return hasStoredProgramLevelFamilies() ? getStoredProgramLevelFamily() : null;
  }
};